<div>
    <h1>Congratulations!</h1>
    <p>You've successfully enrolled in Rabo AgriFinance Vendor Finance online account management!
        You will now be able to make payments, view statements, make changes to your account and more!</p>
</div>
<button style="margin-bottom: 20px;" type="button" class="btn btn-primary" routerLink="/dashboard">Continue to
    Dashboard</button>
<div style="clear:both"></div>